import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rOyakKiraBilgileriYillarWrapper, rValue } from '../../models/.catalog';

export default class OyakKiraTrGeneliAylikGelirDagilimiListeleApi extends ApiBase<
  pList,
  rValue<rOyakKiraBilgileriYillarWrapper>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OyakTrGeneliAylikKiraDagilimListele',
      }),
      options
    );
  }
}
